import React from "react";
import AppRoutes from '../../../config/AppRoutes';

export const MobileDownpayment = ({ downpayment }) => {
  const currentUrl = window.location.href.replace(process.env.REACT_APP_URL, '');
  
  if(currentUrl === AppRoutes.REFINANCE_IRQ_COMPARE_PAGE) {
    return null;
  }
  return (
    <div className="irq-nav-wrapper">
      <div className="mobile-stat-wrapper">
        <span>$</span>
        <span className="bold">
          {parseFloat(downpayment).toLocaleString()}
        </span>
      </div>
      Downpayment
    </div>
  );
};
